// React
import React, {useState} from "react";
// Redux imports
import { useSelector, useDispatch } from "react-redux";
import { setProyecto } from "../../../redux/reducers/proyectos";

import ActionBar, {
  Action,
  ActionGroup,
  // BottomActionGroup
} from 'calcite-react/ActionBar';

// Styled Components
import styled from "styled-components";

const ActionBarLeft = styled.div`
  // float:left;
  // display: inline-flex;
  // position: relative;
  // width: auto;
  // height: 100%;
  // text-align: center;
  // z-index: 2;
  // left: 0px;
  overflow: hidden;
  // background-color: #4c4c4c;
  // color: #fff;
`;

const ItemMenuOptsIcon = styled.div`
  width: 16px;
  height: 16px;
  background: transpararent;
  font-size:0.95rem;
  font-weight:700;
  text-align: center;
`;

const MenuLeftCompraVivienda = props => {
    // const isCollapsed = useSelector(state => state.proyectos.collapsed);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const activeAction = useSelector(state => state.proyectos.activeProyecto);
    const dispatch = useDispatch();

    const proyectosNames = {
      "":'Caracterización Social y Económica',
      "ACOMPAÑAMIENTO_COMPRA_VIVIENDA": "Acompañamiento individual y familiar",
      "EDUFINANZASFAMILIARES_VIVIENDA": "Educación finanzas familiares",
      "APOYOECONOMICO_COMPRA_VIVIENDA": "Apoyo económico",
      "CONFIGURACION": "Configuración del GRB", 
    };

    // useEffect(() => {
    //   dispatch(moduleLEFTPANELLoaded({activeModule:activeAction, headerTitle:proyectosNames[activeAction]}));
    // }, [dispatch]);

    const onToggleCollapse = (e) => {
      setIsCollapsed(!isCollapsed);
    };

    const turnOffModules = () => {
      // dispatch(moduleUSERSLoaded({loaded:false})); // Hide Users
      // dispatch(moduleBENEFICIARIOSLoaded({loaded:false}));
    }

    const actionSelected = (activeAction) => {
      dispatch(setProyecto({activeProyecto:activeAction, collapsed:isCollapsed, headerTitle:proyectosNames[activeAction]}));
      turnOffModules();
      switch (activeAction) {
        case 'ACOMPAÑAMIENTO_COMPRA_VIVIENDA':
          console.log('ACOMPAÑAMIENTO_COMPRA_VIVIENDA');
          break;
        case 'EDUFINANZASFAMILIARES_VIVIENDA':
          console.log('EDUFINANZASFAMILIARES_VIVIENDA');
          break;
        case 'APOYOECONOMICO_COMPRA_VIVIENDA':
          console.log('APOYOECONOMICO_COMPRA_VIVIENDA');
          break;
        
        default:
          break;
      }
    };

    return (
      <ActionBarLeft>
      <ActionBar 
        // showCollapser={false}
        collapseLabel='Ocultar' 
        expandLabel='Expandir' 
        collapsed={isCollapsed}
        onToggleCollapse={onToggleCollapse}
      >
        <ActionGroup>
          <Action
            onClick={() => actionSelected('ACOMPAÑAMIENTO_COMPRA_VIVIENDA')}
            active={activeAction === 'ACOMPAÑAMIENTO_COMPRA_VIVIENDA'}
            icon={<ItemMenuOptsIcon>Ac</ItemMenuOptsIcon>}
          >
            Acompañamiento individual y familiar
          </Action>
          <Action 
              onClick={() => actionSelected('EDUFINANZASFAMILIARES_VIVIENDA')}
              active={activeAction === 'EDUFINANZASFAMILIARES_VIVIENDA'}
              icon={<ItemMenuOptsIcon>Ed</ItemMenuOptsIcon>}
            >
              Educación finanzas familiares
          </Action>
          <Action
            onClick={() => actionSelected('APOYOECONOMICO_COMPRA_VIVIENDA')}
            active={activeAction === 'APOYOECONOMICO_COMPRA_VIVIENDA'}
            icon={<ItemMenuOptsIcon>Ap</ItemMenuOptsIcon>}
          >
            Apoyo económico compra
          </Action>
        
        </ActionGroup>
        {/* <BottomActionGroup>
        <Action icon={<GearIcon />}>Configuración</Action>
      </BottomActionGroup> */}
      </ActionBar>
      </ActionBarLeft>
    )

}

export default MenuLeftCompraVivienda;